/**
 * 策略配置页面配置
 */
import i18n from "@/Language"
import permission from '@/plugins/auth'
import { calcActionColumnWidth } from '@/components/ITable/util'

export const policyConst = {
  USER_AGREEMENT: 0,
  PRIVACY_POLICY: 1,
  COOKIE_POLICY: 2,
}

/**
 * 打开协议页面（用户协议/隐私政策/Cookie政策）
 * @param {string} type - 类型：'userAgreement' | 'privacyPolicy' | 'cookiePolicy'
 */
export const openAgreementPage = (type) => {
    const which = localStorage.getItem('Accept-Language') || 'en-US';
    let tlUrl = '';
    
    // 根据类型和语言构建URL
    const isChinese = which === 'zh-CN';
    
    switch(type) {
        case policyConst.USER_AGREEMENT:
            tlUrl = isChinese 
                ? "/resources/web/haier-energy_serviceAgreement_zh.html"
                : "/resources/web/haier-energy_serviceAgreement_en.html";
            break;
        case policyConst.PRIVACY_POLICY:
            tlUrl = isChinese
                ? "/resources/web/haier-energy_privacyAgreement_zh.html"
                : "/resources/web/haier-energy_privacyAgreement_en.html";
            break;
        case policyConst.COOKIE_POLICY:
            tlUrl = isChinese
                ? "/resources/web/haier-energy_cookiePolicy_zh.html"
                : "/resources/web/haier-energy_cookiePolicy_en.html";
            break;
        default:
            console.error('Invalid type:', type);
            return;
    }
    
    // 在新标签页中打开
    window.open(tlUrl, '_blank');
}

// 操作按钮配置
export const buttonList = (that, row) => [
  {
    label: () => i18n.t('btn.edit'),
    permission: ['policyConfiguration:list:edit'],
    showWhen: permission.hasPermi('policyConfiguration:list:edit'),
    type: 'text',
    clickType: 'edit',
    click: (row) => {
      that.handleEdit(row)
    },
  }
]

// 表格配置
export const InfoConfig = () => {
  const infoConfigList = [
    {
      prop: 'languageText',
      label: i18n.t('title.language'),
      align: 'left',
    },
    // {
    //   prop: 'content',
    //   label: i18n.t('upgrade.content'),
    //   align: 'left',
    //   'show-overflow-tooltip': true,
    //   width: '200'
    // },
    {
      prop: 'createTime',
      label: i18n.t('org.createTime'),
      align: 'left',
    },
    {
      prop: 'updateTime',
      label: i18n.t('role.updateTime'),
      align: 'left',
    }
  ]
  
  // 动态读取操作列的所有权限
  const actionPermi = buttonList().map(item => item.permission[0])
  if (permission.hasPermiOr(actionPermi)) {
    infoConfigList.push({ 
      label: i18n.t("org.action"), 
      prop: "action", 
      align: "center", 
      fixed: 'right', 
      width: calcActionColumnWidth(buttonList()) || '100', 
      slotName: 'action' 
    })
  }
  return infoConfigList
}
